import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["error", "className", "title", "customStyles", "caption", "required", "onMenuOpen"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef, useCallback } from "react";
import Select from "react-select";
import ErrorMessage from "./ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var baseCustomStyles = {
  dropdownIndicator: function dropdownIndicator(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: "4px"
    });
  },
  indicatorSeparator: function indicatorSeparator(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      width: "0"
    });
  },
  IndicatorsContainer: function IndicatorsContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      height: "44px"
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      height: "44px",
      padding: "0 0 0 14px"
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      marginLeft: "0",
      marginRight: "0",
      color: "#aaa"
    });
  },
  singleValue: function singleValue(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: "#444",
      marginLeft: "0",
      marginRight: "0",
      fontSize: "14px"
    });
  },
  input: function input(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      margin: "0",
      paddingBottom: "0px",
      paddingTop: "0px",
      minWidth: "3em",
      color: "#444",
      width: "5em"
    });
  },
  control: function control(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      border: state.isFocused ? "none" : "none",
      backgroundColor: state.isFocused ? "#e6e6e6" : "#e6e6e6"
    });
  },
  menu: function menu(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: "#1E2A31",
      zIndex: 1
    });
  }
};
var SelectField = /*#__PURE__*/forwardRef(function (props, ref) {
  var error = props.error,
      className = props.className,
      title = props.title,
      _props$customStyles = props.customStyles,
      customStyles = _props$customStyles === void 0 ? {} : _props$customStyles,
      caption = props.caption,
      required = props.required,
      onMenuOpen = props.onMenuOpen,
      _props = _objectWithoutProperties(props, _excluded);

  var selectStyles = Object.assign({}, baseCustomStyles, customStyles);
  var handleMenuOpen = useCallback(function () {
    if (onMenuOpen) {
      onMenuOpen();
    }

    setTimeout(function () {
      var menu = document.querySelector(".react-select__menu-list");
      var selectedEl = document.querySelector(".react-select__option--is-selected");

      if (menu && selectedEl) {
        menu.scrollTo(0, selectedEl.offsetTop);
        selectedEl.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start"
        });
      }
    }, 15);
  }, [onMenuOpen]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, _defineProperty({}, styles.required, required)),
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.select, className),
      children: /*#__PURE__*/_jsx(Select, _objectSpread({
        styles: selectStyles,
        ref: ref,
        className: "react-select-container",
        classNamePrefix: "react-select",
        required: required,
        isSearchable: false,
        onMenuOpen: handleMenuOpen
      }, _props))
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.caption,
      children: caption
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
});
SelectField.displayName = "SelectField";
export default SelectField;